import React from 'react';
import styleable from 'react-styleable';
import PropTypes, { bool, number, string } from 'prop-types';
import { useLocalisation } from '@3plearning/lingui-cdn';

import css from './topic-box.scss';

import { ASSIGNMENT_STATUSES } from '../../../skill-quests-mastery-constants';

import ContextModal from '../../../../../components/context-modal/context-modal';
import { CONTEXT_MODAL_POSITION } from '../../../../../components/context-modal/context-modal-constants';

import { Attempt } from './attempt';

export const ASSIGNMENT_TYPE = {
    ASSIGN_REVIEW_UPF: 0,
    ASSIGN_REVIEW_ASSESSMENT: 1,
    VOLUNTARY: 2
};

export const getProgressBoxClassName = (accuracy) => {
    let progressClass = '';

    if (accuracy <= 20) {
        progressClass = css.RED;
    } else if (accuracy > 20 && accuracy <= 40) {
        progressClass = css.ORANGE;
    } else if (accuracy > 40 && accuracy <= 60) {
        progressClass = css.DARK_BLUE;
    } else if (accuracy > 60 && accuracy <= 80) {
        progressClass = css.LIGHT_BLUE;
    } else if (accuracy > 80 && accuracy <= 100) {
        progressClass = css.GREEN;
    }

    return progressClass;
};

const TopicBox = ({ journey }) => {
    const { MODAL_DOWN } = CONTEXT_MODAL_POSITION;
    const { i18n } = useLocalisation();
    const text = {
        boxAccuracyText: (accuracy) =>
            i18n.t`Topic Box - Accuracy - ${accuracy}`,
        boxStepsCompletedText: (completedStepsCount, totalStepsCount) =>
            i18n.t`Topic Box - Completed - ${completedStepsCount} - ${totalStepsCount}`,
        assignReviewUpfText: i18n.t`Assignment Type - Assign Review Upf`,
        assignReviewAssessmentText: i18n.t`Assignment Type - Assign Review Assessment`,
        voluntaryText: i18n.t`Assignment Type - Voluntary`,
        attempts: i18n.t`Attempts`
    };

    /**
     * CLASSNAMES
     */

    const getLearningJourneyBoxClassName = () => {
        const baseClass = `${css['learning-journey-box']} `;

        switch (journey.status) {
            case ASSIGNMENT_STATUSES.NOT_ASSIGNED: {
                return `${baseClass} ${css.NOT_ASSIGNED}`;
            }
            case ASSIGNMENT_STATUSES.IN_PROGRESS: {
                const progressClass = getProgressBoxClassName(journey.accuracy);

                return `${baseClass} ${css.IN_PROGRESS} ${progressClass}`;
            }
            case ASSIGNMENT_STATUSES.ASSIGNED: {
                return `${baseClass} ${css.ASSIGNED}`;
            }
            case ASSIGNMENT_STATUSES.COMPLETED: {
                const progressClass = getProgressBoxClassName(journey.accuracy);

                return `${baseClass} ${css.COMPLETED} ${progressClass}`;
            }
            default: {
                return `${baseClass}`;
            }
        }
    };

    /**
     * RENDERS
     */
    const renderAccuracyText = (accuracy) => {
        if (accuracy) return <p>{text.boxAccuracyText(journey.accuracy)}</p>;
        return null;
    };

    const rendersAssignmentTypeText = (assignmentType) => {
        const {
            ASSIGN_REVIEW_UPF,
            ASSIGN_REVIEW_ASSESSMENT,
            VOLUNTARY
        } = ASSIGNMENT_TYPE;
        const {
            assignReviewUpfText,
            assignReviewAssessmentText,
            voluntaryText
        } = text;
        let returnedText = null;

        switch (assignmentType) {
            case ASSIGN_REVIEW_UPF:
                returnedText = assignReviewUpfText;
                break;
            case ASSIGN_REVIEW_ASSESSMENT:
                returnedText = assignReviewAssessmentText;
                break;
            case VOLUNTARY:
                returnedText = voluntaryText;
                break;
            default:
                break;
        }

        return <p>{returnedText}</p>;
    };

    const renderAttempts = (learningjourney) => {
        const { assignmentsHistory, assignmentType } = learningjourney;
        const assignmentTypeText = rendersAssignmentTypeText(assignmentType);
        const { attempts } = text;
        return (
            <div className={css.attempts}>
                <h3>{attempts}:</h3>
                <div className={css.attemptsContainer}>
                    {assignmentsHistory &&
                        assignmentsHistory.map((assignments) => (
                            <Attempt
                                key={assignmentTypeText}
                                assignmentTypeText={assignmentTypeText}
                                {...assignments}
                            />
                        ))}
                </div>
            </div>
        );
    };

    return (
        <div className={getLearningJourneyBoxClassName()}>
            <ContextModal
                className={css['box-context-modal']}
                show
                position={MODAL_DOWN}
                onClickOutsideHandler={() => {}}
            >
                <div>
                    <p>{journey.name}</p>
                    {renderAccuracyText(journey.accuracy)}
                    <p>
                        {text.boxStepsCompletedText(
                            journey.completedStepsCount,
                            journey.totalStepsCount
                        )}
                    </p>
                    {rendersAssignmentTypeText(journey.assignmentType)}
                    {journey.assignmentsHistory &&
                        journey.assignmentsHistory.length > 0 &&
                        renderAttempts(journey)}
                </div>
            </ContextModal>
        </div>
    );
};

TopicBox.propTypes = {
    journey: PropTypes.shape({
        name: string,
        status: number,
        accuracy: number,
        completedStepsCount: number,
        totalStepsCount: number,
        assignmentsHistory: PropTypes.shape({
            assignmentType: number,
            assignmentStartDate: string,
            isFocusedResult: bool,
            resultAccuracy: number
        })
    })
};

export default styleable(css)(TopicBox);



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/components/topic-box/topic-box.js